import { createSlice } from '@reduxjs/toolkit';
import { IDLE_STATUS, LOADING_STATUS, FAILURE_STATUS } from '../status';
import i18n from '../../i18n';
import {
  fetchAllDAImportacaoByFilterAsync,
  fetchBaixaDAMercadoriasByFilterAsync,
  fetchFollowupsDestinoComDiAsync,
  transferirItensDaAsync,
  fetchEstornoDAMercadoriasByFilterAsync,
  estornarItensDaAsync,
  estornarQuantidadeDaAsync,
} from './declaracoesAduaneirasThunks';
import { NO_REFRESH } from '../refresh';

const initialState = {
  status: IDLE_STATUS,
  error: null,
  list: [],
  count: 0,
  refresh: NO_REFRESH,

  baixaList: [],
  baixaCount: 0,
  baixaStatus: IDLE_STATUS,
  baixaError: null,

  followupsDestinoList: [],
  followupsDestinoStatus: IDLE_STATUS,
  followupsDestinoError: null,

  transferirStatus: IDLE_STATUS,
  transferirError: null,
  transferirResult: null,

  estornoList: [],
  estornoCount: 0,
  estornoStatus: IDLE_STATUS,
  estornoError: null,
  estornarStatus: IDLE_STATUS,
  estornarError: null,
  estornarQuantidadeStatus: IDLE_STATUS,
  estornarQuantidadeError: null,
};

const declaracoesAduaneirasSlice = createSlice({
  name: 'declaracoesAduaneiras',
  initialState,
  reducers: {
    resetStatus: (state) => { state.status = IDLE_STATUS; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDAImportacaoByFilterAsync.pending, (state) => {
        state.status = LOADING_STATUS;
      })
      .addCase(fetchAllDAImportacaoByFilterAsync.fulfilled, (state, action) => {
        state.status = IDLE_STATUS;
        state.list = action?.payload?.data?.itens || [];
        state.count = action?.payload?.data?.totalNumberOfItens || 0;
      })
      .addCase(fetchAllDAImportacaoByFilterAsync.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = i18n.t('com.muralis.qcx.erro.erroCarregarListaFollowUp', {
          mensagem: action.payload || action.error?.message || 'Erro ao carregar',
        });
      });

    builder
      .addCase(fetchBaixaDAMercadoriasByFilterAsync.pending, (state) => {
        state.baixaStatus = LOADING_STATUS;
        state.baixaError = null;
      })
      .addCase(fetchBaixaDAMercadoriasByFilterAsync.fulfilled, (state, action) => {
        state.baixaStatus = IDLE_STATUS;
        state.baixaList = action?.payload?.data?.itens || [];
        state.baixaCount = action?.payload?.data?.totalNumberOfItens || 0;
      })
      .addCase(fetchBaixaDAMercadoriasByFilterAsync.rejected, (state, action) => {
        state.baixaStatus = FAILURE_STATUS;
        state.baixaError = action.payload || action.error?.message || 'Erro ao carregar mercadorias.';
      });

    builder
      .addCase(fetchFollowupsDestinoComDiAsync.pending, (state) => {
        state.followupsDestinoStatus = LOADING_STATUS;
        state.followupsDestinoError = null;
      })
      .addCase(fetchFollowupsDestinoComDiAsync.fulfilled, (state, action) => {
        state.followupsDestinoStatus = IDLE_STATUS;
        state.followupsDestinoList = action?.payload?.data || [];
      })
      .addCase(fetchFollowupsDestinoComDiAsync.rejected, (state, action) => {
        state.followupsDestinoStatus = FAILURE_STATUS;
        state.followupsDestinoError = action.payload || action.error?.message || 'Erro ao carregar followups de destino.';
      });

    builder
      .addCase(transferirItensDaAsync.pending, (state) => {
        state.transferirStatus = LOADING_STATUS;
        state.transferirError = null;
        state.transferirResult = null;
      })
      .addCase(transferirItensDaAsync.fulfilled, (state, action) => {
        state.transferirStatus = IDLE_STATUS;
        state.transferirResult = action?.payload?.result || { success: true };
      })
      .addCase(transferirItensDaAsync.rejected, (state, action) => {
        state.transferirStatus = FAILURE_STATUS;
        state.transferirError = action.payload || action.error?.message || 'Erro ao transferir.';
      });

    builder
      // FETCH ESTORNO
      .addCase(fetchEstornoDAMercadoriasByFilterAsync.pending, (state) => {
        state.estornoStatus = LOADING_STATUS;
        state.estornoError = null;
      })
      .addCase(fetchEstornoDAMercadoriasByFilterAsync.fulfilled, (state, action) => {
        state.estornoStatus = IDLE_STATUS;
        state.estornoList = action?.payload?.data?.itens || [];
        state.estornoCount = action?.payload?.data?.totalNumberOfItens || 0;
      })
      .addCase(fetchEstornoDAMercadoriasByFilterAsync.rejected, (state, action) => {
        state.estornoStatus = FAILURE_STATUS;
        state.estornoError = action.payload || action.error?.message || 'Erro ao carregar mercadorias para estorno.';
      })

      // ESTORNAR
      .addCase(estornarItensDaAsync.pending, (state) => {
        state.estornarStatus = LOADING_STATUS;
        state.estornarError = null;
      })
      .addCase(estornarItensDaAsync.fulfilled, (state) => {
        state.estornarStatus = IDLE_STATUS;
      })
      .addCase(estornarItensDaAsync.rejected, (state, action) => {
        state.estornarStatus = FAILURE_STATUS;
        state.estornarError = action.payload || action.error?.message || 'Erro ao estornar.';
      })

      .addCase(estornarQuantidadeDaAsync.pending, (state) => {
        state.estornarQuantidadeStatus = LOADING_STATUS;
        state.estornarQuantidadeError = null;
      })
      .addCase(estornarQuantidadeDaAsync.fulfilled, (state) => {
        state.estornarQuantidadeStatus = IDLE_STATUS;
      })
      .addCase(estornarQuantidadeDaAsync.rejected, (state, action) => {
        state.estornarQuantidadeStatus = FAILURE_STATUS;
        state.estornarQuantidadeError = action.payload || action.error?.message || 'Erro ao estornar quantidade.';
      });
  },
});

export const { resetStatus, clearError } = declaracoesAduaneirasSlice.actions;
export default declaracoesAduaneirasSlice.reducer;


export const selectDeclaracoesAduaneirasStatus = (state) => state.declaracoesAduaneiras.status;
export const selectDeclaracoesAduaneirasError = (state) => state.declaracoesAduaneiras.error;
export const selectDeclaracoesAduaneirasList = (state) => state.declaracoesAduaneiras.list;
export const selectDeclaracoesAduaneirasCount = (state) => state.declaracoesAduaneiras.count;

export const selectBaixaDAMercadoriasStatus = (state) => state.declaracoesAduaneiras.baixaStatus;
export const selectBaixaDAMercadoriasError = (state) => state.declaracoesAduaneiras.baixaError;
export const selectBaixaDAMercadoriasList = (state) => state.declaracoesAduaneiras.baixaList;
export const selectBaixaDAMercadoriasCount = (state) => state.declaracoesAduaneiras.baixaCount;

export const selectFollowupsDestinoStatus = (state) => state.declaracoesAduaneiras.followupsDestinoStatus;
export const selectFollowupsDestinoError = (state) => state.declaracoesAduaneiras.followupsDestinoError;
export const selectFollowupsDestinoList = (state) => state.declaracoesAduaneiras.followupsDestinoList;

export const selectTransferirStatus = (state) => state.declaracoesAduaneiras.transferirStatus;
export const selectTransferirError = (state) => state.declaracoesAduaneiras.transferirError;
export const selectTransferirResult = (state) => state.declaracoesAduaneiras.transferirResult;

export const selectEstornoDAMercadoriasStatus = (st) => st.declaracoesAduaneiras.estornoStatus;
export const selectEstornoDAMercadoriasList = (st) => st.declaracoesAduaneiras.estornoList;
export const selectEstornoDAMercadoriasCount = (st) => st.declaracoesAduaneiras.estornoCount;
export const selectEstornarStatus = (st) => st.declaracoesAduaneiras.estornarStatus;
export const selectEstornarQuantidadeStatus = (st) => st.declaracoesAduaneiras.estornarQuantidadeStatus;
export const selectEstornarQuantidadeError = (st) => st.declaracoesAduaneiras.estornarQuantidadeError;


